export { genSortableID as genRandomID } from "@shared/id";

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes;
  let unit = -1;
  // 1023.5 KB would otherwise round to "1024 KB"
  while (value >= 1023.5 && unit < units.length - 1) {
    value /= 1024;
    unit++;
  }
  return `${value.toFixed(value < 100 ? 1 : 0)} ${units[unit]}`;
}
